import React from "react";
import { Router } from "react-router-dom";
import { useAuth0 } from "./react-auth0-spa";
import history from "./utils/history";

import Loading from "./components/auxil/Loading";
import MainLayout from "./components/MainLayout/MainLayout";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";

initFontAwesome();

const App = () => {
  const {
    loading,
    user,
    isAuthenticated,
    loginWithRedirect,
    getTokenSilently
  } = useAuth0();

  if (loading) {
    return <Loading />;
  }
  if (!isAuthenticated) {
    loginWithRedirect({ appState: { targetUrl: window.location.pathname } });
  }

  return (
    <Router history={history}>
      {isAuthenticated && <MainLayout user={user} loading={loading} token={getTokenSilently()} />}
    </Router>
  );
};

export default App;
